import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/analytics";

firebase.initializeApp({
  apiKey: "AIzaSyBf_9s4VjyuCeAyGpK7076y5UWGZ1-zJqA",
  authDomain: "face-studio-316ea.firebaseapp.com",
  projectId: "face-studio-316ea",
  storageBucket: "face-studio-316ea.appspot.com",
  messagingSenderId: "1012429100141",
  appId: "1:1012429100141:web:467fe5223be3430f029b64",
  measurementId: "G-RLPF3PJS82"
});

const auth = firebase.auth();
const db = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp();
const functions = firebase.app().functions("europe-west1");
const analytics = firebase.analytics();

if (location.hostname === "localhost") {
  auth.useEmulator("http://localhost:9099");
  db.useEmulator("localhost", 9000);
  functions.useEmulator("localhost", 5001);
}

export { auth, db, timestamp, functions, analytics };
